import apiService from "../../api/api.service";
import { ReorderResponse, GetReorderRequest } from "./reorder.types";

/**
 * Get customer's buy again products
 */
export const fetchReorderProducts = (params?: GetReorderRequest) => {
  return apiService.get<ReorderResponse>("/customers/buy-again", { params });
};